import React from 'react';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import AspectRatio from '@/components/layout/AspectRatio';
import { cn } from '@/lib/utils';
import BackgroundImage from '@/components/media/BackgroundImage/background-image';
import LinkButton from '../Link';
import type { ImageButtonElement, ImageButtonProps } from './types';
import { withRef } from '@/lib/with-ref';

const ButtonImage = withRef<ImageButtonElement, ImageButtonProps>(
  (
    {
      width = 'w-[150px]',
      height = 'w-[150px]',
      src,
      alt,
      href,
      presetRatio = 'square',
      responsive = {},
      aspectRatioProps = {},
      linkProps = {},
      backgroundImageProps = {},
      className = '',
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <AspectRatio
        presetRatio={presetRatio}
        className={cn(width, height, aspectRatioProps.className)}
        {...aspectRatioProps}
      >
        <ResponsiveWrapper responsive={responsive}>
          <LinkButton
            href={href}
            className={cn('w-full h-full', className)}
            variant="ghost"
            linkProps={linkProps}
            {...props}
          >
            <BackgroundImage
              src={src}
              alt={alt}
              fill={true}
              sizes="50vw"
              presetRatio={presetRatio}
              {...backgroundImageProps}
            >
              {children}
            </BackgroundImage>
          </LinkButton>
        </ResponsiveWrapper>
      </AspectRatio>
    );
  },
);

export default React.memo(ButtonImage);
